export const defaultLanguage = 'en';

export const featuredLanguages = ['en', 'de', 'fr', 'es', 'it'];

export const keywordResearchLanguages = {
    DZ: {
        fr: 'French',
        ar: 'Arabic',
    },
    AO: {
        pt: 'Portuguese',
    },
    AZ: {
        az: 'Azeri',
    },
    AR: {
        es: 'Spanish',
    },
    AU: {
        en: 'English',
    },
    AT: {
        de: 'German',
    },
    BH: {
        ar: 'Arabic',
    },
    BD: {
        bn: 'Bengali',
    },
    AM: {
        hy: 'Armenian',
    },
    BE: {
        fr: 'French',
        nl: 'Dutch',
        de: 'German',
    },
    BO: {
        es: 'Spanish',
    },
    BA: {
        bs: 'Bosnian',
    },
    BR: {
        pt: 'Portuguese',
    },
    BG: {
        bg: 'Bulgarian',
    },
    MM: {
        en: 'English',
    },
    KH: {
        en: 'English',
    },
    CM: {
        fr: 'French',
    },
    CA: {
        en: 'English',
        fr: 'French',
    },
    LK: {
        en: 'English',
    },
    CL: {
        es: 'Spanish',
    },
    TW: {
        'zh-TW': 'Chinese (Traditional)',
    },
    CO: {
        es: 'Spanish',
    },
    CR: {
        es: 'Spanish',
    },
    HR: {
        hr: 'Croatian',
    },
    CY: {
        el: 'Greek',
        en: 'English',
    },
    CZ: {
        cs: 'Czech',
    },
    DK: {
        da: 'Danish',
    },
    EC: {
        es: 'Spanish',
    },
    SV: {
        es: 'Spanish',
    },
    EE: {
        et: 'Estonian',
    },
    FI: {
        fi: 'Finnish',
    },
    FR: {
        fr: 'French',
    },
    DE: {
        de: 'German',
    },
    GH: {
        en: 'English',
    },
    GR: {
        el: 'Greek',
        en: 'English',
    },
    GT: {
        es: 'Spanish',
    },
    HK: {
        en: 'English',
        'zh-TW': 'Chinese (Traditional)',
    },
    HU: {
        hu: 'Hungarian',
    },
    IN: {
        en: 'English',
        hi: 'Hindi',
    },
    ID: {
        en: 'English',
        id: 'Indonesian',
    },
    IE: {
        en: 'English',
    },
    IL: {
        he: 'Hebrew',
        ar: 'Arabic',
    },
    IT: {
        it: 'Italian',
    },
    CI: {
        fr: 'French',
    },
    JP: {
        ja: 'Japanese',
    },
    // Supports only russian language at the moment, so skipping
    // KZ: {
    //     ru: 'Russian ',
    // },
    JO: {
        ar: 'Arabic',
    },
    KE: {
        en: 'English',
    },
    KR: {
        ko: 'Korean',
    },
    LV: {
        lv: 'Latvian',
    },
    LT: {
        lt: 'Lithuanian',
    },
    MY: {
        en: 'English',
        ms: 'Malay',
    },
    MT: {
        en: 'English',
    },
    MX: {
        es: 'Spanish',
    },
    MD: {
        ro: 'Romanian',
    },
    MA: {
        ar: 'Arabic',
        fr: 'French',
    },
    NL: {
        nl: 'Dutch',
    },
    NZ: {
        en: 'English',
    },
    NI: {
        es: 'Spanish',
    },
    NG: {
        en: 'English',
    },
    NO: {
        nb: 'Norwegian (Bokmål)',
    },
    PK: {
        en: 'English',
        ur: 'Urdu',
    },
    PA: {
        es: 'Spanish',
    },
    PY: {
        es: 'Spanish',
    },
    PE: {
        es: 'Spanish',
    },
    PH: {
        en: 'English',
        tl: 'Tagalog',
    },
    PL: {
        pl: 'Polish',
    },
    PT: {
        pt: 'Portuguese',
    },
    RO: {
        ro: 'Romanian',
    },
    SA: {
        ar: 'Arabic',
    },
    SN: {
        fr: 'French',
    },
    RS: {
        sr: 'Serbian',
    },
    SG: {
        en: 'English',
        'zh-CN': 'Chinese (Simplified)',
    },
    SK: {
        sk: 'Slovak',
    },
    VN: {
        en: 'English',
        vi: 'Vietnamese',
    },
    SI: {
        sl: 'Slovenian',
    },
    ZA: {
        en: 'English',
    },
    ES: {
        es: 'Spanish',
    },
    SE: {
        sv: 'Swedish',
    },
    CH: {
        de: 'German',
        fr: 'French',
        it: 'Italian',
    },
    TH: {
        th: 'Thai',
    },
    AE: {
        ar: 'Arabic',
        en: 'English',
    },
    TN: {
        ar: 'Arabic',
    },
    TR: {
        tr: 'Turkish',
    },
    UA: {
        uk: 'Ukrainian',
    },
    MK: {
        mk: 'Macedonian',
    },
    EG: {
        ar: 'Arabic',
        en: 'English',
    },
    GB: {
        en: 'English',
    },
    US: {
        en: 'English',
        es: 'Spanish',
    },
    BF: {
        fr: 'French',
    },
    UY: {
        es: 'Spanish',
    },
    VE: {
        es: 'Spanish',
    },
};

export const languages = {
    // ar: 'Arabic ',
    // bg: 'Bulgarian ',
    // bn: 'Bengali ',
    // ca: 'Catalan ',
    // cs: 'Czech ',
    // da: 'Danish ',
    de: 'German ',
    // el: 'Greek ',
    en: 'English ',
    es: 'Spanish ',
    // et: 'Estonian ',
    // fa: 'Farsi ',
    // fi: 'Finnish ',
    fr: 'French ',
    // hi: 'Hindi ',
    // hr: 'Croatian ',
    // hu: 'Hungarian ',
    // id: 'Indonesian ',
    // is: 'Icelandic ',
    it: 'Italian ',
    // iw: 'Hebrew (old) ',
    // ja: 'Japanese ',
    // ko: 'Korean ',
    // lt: 'Lithuanian ',
    // lv: 'Latvian ',
    // ms: 'Malay ',
    // nl: 'Dutch ',
    // no: 'Norwegian ',
    // pl: 'Polish ',
    // pt: 'Portuguese ',
    // ro: 'Romanian ',
    // ru: 'Russian ',
    // sk: 'Slovak ',
    // sl: 'Slovenian ',
    // sr: 'Serbian ',
    // sv: 'Swedish ',
    // ta: 'Tamil ',
    // te: 'Telugu ',
    // th: 'Thai ',
    // tl: 'Tagalog ',
    // tr: 'Turkish ',
    // uk: 'Ukrainian ',
    // ur: 'Urdu ',
    // vi: 'Vietnamese ',
    // zh_CN: 'Chinese (Simplified) ',
    // zh_TW: 'Chinese (Traditional) ',
};

export const getLanguagesWithDefaultHighlighted = () => {
    let data = { ...languages };
    data[defaultLanguage] = `${data[defaultLanguage]} (default)`;

    return data;
};
